import React, { createContext, useCallback, useEffect, useState } from "react";

import placementTrackerAPI from '../services/api/PlacementTrackerAPI';

const PlacementCycleContext = createContext();

export const PlacementCycleContextProvider = ( { children } ) => {

    const [cycleId, setCycleId] = useState( "" );

    const { data: cycles = [], isLoading: cyclesLoading, isFetching: cyclesFetching, error: cyclesError, refetch: refetchCycles } = placementTrackerAPI.cycles.useAll();

    useEffect( () => {
        if ( cycleId && !cyclesLoading && !cyclesFetching && !cyclesError && !cycles.some( cycle => cycle.placement_cycle === cycleId ) ) {
            setCycleId( '' );
        }
    }, [cycleId, cycles, cyclesLoading, cyclesFetching, cyclesError] );

    const getCycleLabel = useCallback( id => {
        if ( !id ) return 'All Cycles';
        const match = cycles.find( cycle => cycle.placement_cycle === id );
        return match?.placement_cycle_short || match?.placement_cycle || id;
    }, [cycles] );

    const value = {
        cycles,
        cycleId,
        cyclesLoading,
        cyclesError,
        refetchCycles,
        setCycleId,
        getCycleLabel,
    };

    return (
        <PlacementCycleContext.Provider value={value}>
            {children}
        </PlacementCycleContext.Provider>
    );
}

export const usePlacementCycleContext = () => React.useContext( PlacementCycleContext );

export default PlacementCycleContextProvider;
